'use client';

import { Button } from '@common/components';
import { SvgExpandWindow } from '@common/icon';
import { useState } from 'react';

import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';

import { MarketShareDrawer } from './MarketShareDrawer';

export const MarketShareButton = () => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const [isOpen, setIsOpen] = useState(false);
  const router = useCustomRouter();

  return (
    <>
      <Button
        aria-label="공유하기"
        className="relative size-26 p-0"
        dimensions="H26"
        theme="primary-text"
        onClick={() => {
          if (!isLogin) {
            router.push(
              ROUTES.LOGIN.withSearchParams({
                searchParams: {
                  redirect: location.pathname + location.search,
                },
              }),
            );

            return;
          }

          setIsOpen(true);
        }}
      >
        <SvgExpandWindow className="size-24" />
      </Button>
      <MarketShareDrawer opened={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};
